import { render, staticRenderFns } from "./MarketingLandingPage.vue?vue&type=template&id=13c72fea&scoped=true&"
import script from "./MarketingLandingPage.vue?vue&type=script&lang=js&"
export * from "./MarketingLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./MarketingLandingPage.vue?vue&type=style&index=0&id=13c72fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c72fea",
  null
  
)

export default component.exports